import { render, staticRenderFns } from "./FolderLayer.vue?vue&type=template&id=42eda827&scoped=true"
import script from "./FolderLayer.vue?vue&type=script&lang=js"
export * from "./FolderLayer.vue?vue&type=script&lang=js"
import style0 from "./FolderLayer.vue?vue&type=style&index=0&id=42eda827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eda827",
  null
  
)

export default component.exports